import fetch from 'cross-fetch'

import { API_ADDR } from '../config/config'
export const ADDRESS_TRANSACTION_INIT = 'ADDRESSES_TRANSACTION_INIT'
export const ADDRESS_TRANSACTION_UPDATE = 'ADDRESS_TRANSACTION_UPDATE'

export function initAddressTransaction() {
  return {
    type: ADDRESS_TRANSACTION_INIT,
  }
}
export function updateAddressTransaction(addressTransaction, total, status) {
  return {
    type: ADDRESS_TRANSACTION_UPDATE,
    payload: {
      result: addressTransaction,
      total: total,
      status: status,
    },
  }
}

export function loadAddressTransaction(address, offset, limit, date) {
  var start = 0
  var end = 0
  if (date != null) {
    if (date.length == 2) {
      start = date[0].valueOf()
      end = date[1].valueOf()
    }
  }

  return (dispatch) => {
    dispatch(initAddressTransaction())
    fetch(
      `${API_ADDR}/address/transactions/${address}?start=${start}&end=${end}&num=${offset}&limit=${limit}&sort=desc`,
      {
        method: 'GET',
        mode: 'cors',
      }
    )
      .then((res) => res.json())
      .then(async (res) => {
        dispatch(updatePageAddressTransactionTotal(res.data.total + 1))
        dispatch(updatePageAddressTransactionStart(res.data.total))
        dispatch(updateAddressTransaction(res.data.result, res.data.total, res.status))
      })
      .catch((err) => {})
  }
}

export const PAGE_ADDRESS_TRANSACTION_INIT = 'PAGE_ADDRESS_TRANSACTION_INIT'
export const PAGE_ADDRESS_TRANSACTION_UPDATE = 'PAGE_ADDRESS_TRANSACTION_UPDATE'
export const PAGE_ADDRESS_TRANSACTION_TOTAL_UPDATE = 'PAGE_ADDRESS_TRANSACTION_TOTAL_UPDATE'
export const PAGE_ADDRESS_TRANSACTION_LIMIT_UPDATE = 'PAGE_ADDRESS_TRANSACTION_LIMIT_UPDATE'
export const PAGE_ADDRESS_TRANSACTION_START_UPDATE = 'PAGE_ADDRESS_TRANSACTION_START_UPDATE'

export function initPageAddressTransaction() {
  return {
    type: PAGE_ADDRESS_TRANSACTION_INIT,
  }
}
export function updatePageAddressTransaction(page) {
  return {
    type: PAGE_ADDRESS_TRANSACTION_UPDATE,
    payload: page,
  }
}

export function updatePageAddressTransactionTotal(total) {
  return {
    type: PAGE_ADDRESS_TRANSACTION_TOTAL_UPDATE,
    payload: total,
  }
}

export function updatePageAddressTransactionLimit(limit) {
  return {
    type: PAGE_ADDRESS_TRANSACTION_LIMIT_UPDATE,
    payload: limit,
  }
}

export function updatePageAddressTransactionStart(start_page) {
  return {
    type: PAGE_ADDRESS_TRANSACTION_START_UPDATE,
    payload: start_page,
  }
}
